import { AlertCircle } from 'lucide-react';
import type { ReactNode } from 'react';

import type { ApiFailure } from '../../lib/http/errors';
import { Alert, AlertDescription, AlertTitle } from '../../ui/alert';
import { Button } from '../../ui/button';
import { st } from './messages';

export function failureSentence(failure: ApiFailure): string {
  switch (failure.kind) {
    case 'conflict':
      return st('failure.conflict', { message: failure.message });
    case 'invalid':
      return failure.message;
    default:
      return st(`failure.${failure.kind}`);
  }
}

export function ErrorState(props: { failure: ApiFailure; onRetry?: () => void }): ReactNode {
  return (
    <Alert variant="destructive" role="alert">
      <AlertCircle aria-hidden />
      <AlertTitle>{failureSentence(props.failure)}</AlertTitle>
      {props.onRetry !== undefined && (
        <AlertDescription>
          {/* `outline` has no foreground of its own; unset it would inherit
           * the alert's `text-destructive`, which the dark destructive
           * surface cannot clear 4.5:1 against. */}
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="text-foreground"
            onClick={props.onRetry}
          >
            {st('retry')}
          </Button>
        </AlertDescription>
      )}
    </Alert>
  );
}
